import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let alive = true;
        let hasToken = false;
        try {
            hasToken = !!localStorage.getItem("gabs_token") || document.cookie.includes("access_token");
        } catch {
            /* noop */
        }
        if (!hasToken) {
            setLoading(false);
            return () => {
                alive = false;
            };
        }
        api.get("/auth/me")
            .then((r) => alive && setUser(r.data))
            .catch(() => alive && setUser(null))
            .finally(() => alive && setLoading(false));
        return () => {
            alive = false;
        };
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        if (data?.access_token) {
            try {
                localStorage.setItem("gabs_token", data.access_token);
            } catch {
                /* noop */
            }
        }
        setUser(data.user);
        return data.user;
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch {
            /* noop */
        }
        try {
            localStorage.removeItem("gabs_token");
        } catch {
            /* noop */
        }
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used within AuthProvider");
    return ctx;
}
